import request from "superagent";
import { GET_HOMEPAGE, SET_FETCHING } from "../";
export default () => (dispatch) => {
  dispatch({
    type: SET_FETCHING,
    payload: true,
  });

  request
    .get(`${process.env.REACT_APP_PUBLISHER_API}/publisher`)
    .set("Content-Type", "text/plain")
    .then((response, error) => {
      if(response.body.statusCode === 200 ) {
        dispatch({
          type: GET_HOMEPAGE,
          payload: response.body.devMessage,
        });
      }
      dispatch({
        type: SET_FETCHING,
        payload: false,
      });
    })
    .catch((error) => {
      dispatch({
        type: SET_FETCHING,
        payload: false,
      });
    });
};
